import { PAGE_PATHS, useRouter } from '@/lib/router';

/**
 * The 404 view (bundle `qs()` "not-found" branch). Markup and inline styles are production's;
 * the headings and the button take their type from the stylesheet exactly as before.
 */
export function NotFound() {
  const { navigate } = useRouter();
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--space-8)',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '500px' }}>
        <div
          style={{
            fontSize: 'var(--text-8xl, 4rem)',
            color: 'var(--color-primary)',
            fontFamily: 'var(--font-heading-alt)',
            marginBottom: 'var(--space-4)',
          }}
        >
          404
        </div>
        <h1
          style={{
            fontFamily: 'var(--font-heading-alt)',
            letterSpacing: '0.1em',
            marginBottom: 'var(--space-4)',
            // UI-R12 changed this heading's LEVEL, not its size. The reset sizes h1 at
            // --text-7xl and h2 at --text-5xl, so without this the 404 view would grow by
            // 115px — a visible change made by an accessibility fix, which is not allowed.
            fontSize: 'var(--text-5xl)',
          }}
        >
          PAGE NOT FOUND
        </h1>
        <p style={{ color: 'var(--color-text-secondary)', marginBottom: 'var(--space-8)', lineHeight: 1.6 }}>
          This path does not exist in the Matrix. Return to known coordinates.
        </p>
        <button
          className="btn btn--solid"
          onClick={() => {
            navigate(PAGE_PATHS.home);
          }}
        >
          RETURN HOME
        </button>
      </div>
    </div>
  );
}
